// Inline rename in the library-links tables: the pencil swaps the name for a
// small PATCH form. Direct binding on turbolinks:load (namespaced so rebinds
// never stack) — the tables are server-rendered, never injected.

function bindRenameToggles() {
  $(".js-token-rename")
    .off("click.renameToken")
    .on("click.renameToken", function () {
      var $container = $(this).closest("div")
      $container.find(".js-token-name").addClass("d-none")
      $(this).addClass("d-none")
      $container
        .find(".js-token-rename-form")
        .removeClass("d-none")
        .find("input[type=text]")
        .trigger("focus")
    })
}

$(document).on("turbolinks:load", bindRenameToggles)
